import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "../../layouts/Auth.css";
import { config } from "../../config";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${config.apiBaseUrl}/auth/login`, {
        email: email,
        password: password,
      });
      localStorage.setItem("token", response.data);
      window.dispatchEvent(new Event("auth-state-changed"));
      navigate("/");
    } catch (error: any) {
      console.error("Login error:", error);
      const message = error?.response?.data?.body?.detail || error?.response?.data?.message;
      setError(message || "Login failed. Please check your credentials and try again.");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <Link to="/" className="auth-brand" aria-label="iFoto home">
          <img className="auth-brand-logo" src="/stillwave-logo.svg" alt="" />
        </Link>

        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-subtitle">Sign in to upload and manage your photos.</p>

        <form className="auth-form" onSubmit={handleLogin}>
          <label className="auth-field">
            Email
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label className="auth-field">
            Password
            <input
              type="password"
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          {error && <div className="auth-error">{error}</div>}

          <div className="auth-actions">
            <button type="submit" className="btn primary">
              Login with Email
            </button>
          </div>
        </form>

      </div>
    </div>
  );
}

export default Login;